var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from 'react';
import { Empty, Popover, Collapse } from 'antd';
import { Addon } from '@antv/x6';
import { getNodeReactComponent, useXFlowApp, } from '@antv/xflow';
import { Log } from '../../util';
import AppContext from '../../context';
import { XFlowNode } from './node';
var Panel = Collapse.Panel;
export var defaultNodeFactory = function (args) {
    return new XFlowNode(args);
};
export var renderNode = function (props) {
    var nodeConfig = props.nodeConfig, onMouseDown = props.onMouseDown, graphConfig = props.graphConfig, modelService = props.modelService, commandService = props.commandService;
    if (!graphConfig) {
        return React.createElement("div", null);
    }
    var renderKey = graphConfig.nodeTypeParser(nodeConfig);
    var reactComponent = graphConfig.nodeRender.get(renderKey);
    return (React.createElement("div", { onMouseDown: onMouseDown }, React.createElement(reactComponent, {
        commands: commandService,
        modelService: modelService,
        data: nodeConfig,
        isNodeTreePanel: true,
    })));
};
export var NodeTitle = function (props) {
    var _a = React.useState(false), isVisible = _a[0], setVisible = _a[1];
    var prefixClz = props.prefixClz, graphConfig = props.graphConfig, commandService = props.commandService, modelService = props.modelService, popoverContent = props.popoverContent, onMouseDown = props.onMouseDown, item = props.item;
    return (React.createElement(React.Fragment, null,
        popoverContent && (React.createElement(Popover, { placement: "right", destroyTooltipOnHide: true, content: popoverContent, visible: isVisible, style: {
                color: 'red',
            }, onVisibleChange: function (val) {
                setVisible(val);
            } },
            React.createElement("div", { className: "".concat(prefixClz, "-node-wrapper"), onMouseEnter: function () {
                    setVisible(true);
                } }, renderNode({
                graphConfig: graphConfig,
                commandService: commandService,
                onMouseDown: onMouseDown,
                modelService: modelService,
                nodeConfig: item,
            })))),
        !popoverContent && (React.createElement("div", { className: "".concat(prefixClz, "-node-wrapper"), onMouseEnter: function () {
                setVisible(true);
            } }, renderNode({
            graphConfig: graphConfig,
            commandService: commandService,
            onMouseDown: onMouseDown,
            modelService: modelService,
            nodeConfig: item,
        })))));
};
export var NodePanelBody = function (props) {
    var x6NodeFactory = props.x6NodeFactory, dndOptions = props.dndOptions, onNodeDrop = props.onNodeDrop, state = props.state, prefixClz = props.prefixClz, registerNode = props.registerNode, _a = props.defaultActiveKey, defaultActiveKey = _a === void 0 ? ['official', 'custom'] : _a;
    var flowchartId = useContext(AppContext).flowchartId;
    var _b = (registerNode !== null && registerNode !== void 0 ? registerNode : {}).title, title = _b === void 0 ? '混合节点' : _b;
    var _c = useXFlowApp(), graphProvider = _c.graphProvider, modelService = _c.modelService, commandService = _c.commandService;
    var _d = React.useState(), dnd = _d[0], setDnd = _d[1];
    /** 获取graph实例 */
    var _e = React.useState(), graph = _e[0], setGraph = _e[1];
    graphProvider.getGraphInstance().then(function (x6Graph) {
        setGraph(x6Graph);
    });
    var graphConfig = undefined;
    graphProvider.getGraphOptions().then(function (x6GraphConfig) {
        graphConfig = x6GraphConfig;
    });
    React.useEffect(function () {
        if (!graph) {
            return;
        }
        var dndInstance = new Addon.Dnd(__assign(__assign({ scaled: false, animation: false }, dndOptions), { target: graph, 
            /** 这里考虑到需要新增群组的需求，不使用x6的getDropNod方法
             * 在validateNode时调用command添加
             */
            validateNode: function (droppingNode, options) { return __awaiter(void 0, void 0, void 0, function () {
                var nodeConfig;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            nodeConfig = __assign(__assign(__assign({}, droppingNode.getData()), droppingNode.getPosition()), { flowchartId: flowchartId });
                            if (!onNodeDrop) return [3 /*break*/, 2];
                            return [4 /*yield*/, onNodeDrop(nodeConfig, commandService, modelService)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            Log.error('onNodeDrop method is required in NodeTree Panel');
                            _a.label = 3;
                        case 3: return [2 /*return*/, false];
                    }
                });
            }); } }));
        setDnd(dndInstance);
    }, [commandService, dndOptions, graph, modelService, onNodeDrop]);
    var onMouseDown = React.useCallback(function (nodeConfig) { return function (e) {
        if (!graph || !dnd || !graphConfig) {
            return;
        }
        var renderKey = graphConfig.nodeTypeParser(nodeConfig);
        var _a = nodeConfig.width, width = _a === void 0 ? 180 : _a, _b = nodeConfig.height, height = _b === void 0 ? 40 : _b;
        var reactComponent = graphConfig.nodeRender.get(renderKey);
        var wrappedComponent = getNodeReactComponent(reactComponent, commandService, modelService);
        var nodeData = {
            data: nodeConfig,
            width: width,
            height: height,
            // X6_NODE_PORTAL_NODE_VIEW
            view: graphConfig.graphId,
            component: wrappedComponent,
        };
        var x6Node = x6NodeFactory ? x6NodeFactory(nodeData) : defaultNodeFactory(nodeData);
        dnd.start(x6Node, e.nativeEvent);
    }; }, [commandService, dnd, graph, graphConfig, modelService, x6NodeFactory]);
    var renderTree = React.useCallback(function (treeList) {
        if (treeList === void 0) { treeList = []; }
        return treeList.map(function (item) {
            var popoverContent = item.popoverContent;
            return (React.createElement(NodeTitle, { item: item, key: item.id, onMouseDown: onMouseDown(item), popoverContent: popoverContent, prefixClz: prefixClz, modelService: modelService, commandService: commandService, graphConfig: graphConfig }));
        });
    }, [commandService, graphConfig, modelService, onMouseDown, prefixClz]);
    var customNode = state.treeData.filter(function (item) { return item.isCustom; });
    var officialNode = state.treeData.filter(function (item) { return !item.isCustom; });
    var searchCustomNode = state.searchList.filter(function (item) { return item.isCustom; });
    var searchOfficialNode = state.searchList.filter(function (item) { return !item.isCustom; });
    var hasCustomNode = customNode.length > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "".concat(prefixClz, "-body") },
            React.createElement(Collapse, { defaultActiveKey: defaultActiveKey, style: { border: 'none' } },
                React.createElement(Panel, { header: "\u901A\u7528\u8282\u70B9", key: "official", style: { border: 'none' } },
                    !state.keyword && React.createElement("div", { className: "".concat(prefixClz, "-official") }, renderTree(officialNode)),
                    state.searchList.length > 0 && (React.createElement("div", { className: "".concat(prefixClz, "-official") }, renderTree(searchOfficialNode)))),
                hasCustomNode && (React.createElement(Panel, { header: title, key: "custom", style: { border: 'none' } },
                    !state.keyword && React.createElement("div", { className: "".concat(prefixClz, "-custom") }, renderTree(customNode)),
                    state.searchList.length > 0 && (React.createElement("div", { className: "".concat(prefixClz, "-custom") }, renderTree(searchCustomNode)))))),
            state.keyword && state.searchList.length === 0 && React.createElement(Empty, { style: { marginTop: '48px' } }))));
};
